import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    brands: [],
  },
  getters: {
    brands(state) {
      return state.brands
    },
    user(state) {
      return state.user
    },
    authenticated(state) {
      return state.user.loggedIn
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_BRANDS(state, data) {
      state.brands = data;
    }
  },
  actions: {
    storeBrands({ commit }, brands) {
      commit("SET_BRANDS", brands);
    },
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          user: user,
        });
      } else {
        commit("SET_USER", null);
      }
    },
  }
});
